import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useCallback,
} from 'react';
import styles from './TabComponent.module.scss';

const Tab = ({
  tabs,
  setPageTitle,
  activeTab: controlledActiveTab,
  onChange,
  className = '',
  tabContentClass = '',
}) => {
  const isControlled = controlledActiveTab !== undefined;
  const [internalActiveTab, setInternalActiveTab] = useState(0);

  const activeTab = isControlled ? controlledActiveTab : internalActiveTab;

  const headerRef = useRef(null);
  const indicatorRef = useRef(null);
  const btnRefs = useRef([]);

  const setActive = (index) => {
    if (!isControlled) setInternalActiveTab(index);
    if (onChange) onChange(index);
    if (setPageTitle) setPageTitle(tabs[index].label);
  };

  const positionIndicator = useCallback(() => {
    const btn = btnRefs.current[activeTab];
    const indicator = indicatorRef.current;
    if (!btn || !indicator) return;
    const { offsetLeft, offsetWidth } = btn;
    indicator.style.transform = `translateX(${offsetLeft}px)`;
    indicator.style.width = `${offsetWidth}px`;
  }, [activeTab]);

  useLayoutEffect(() => {
    positionIndicator();
  }, [activeTab, positionIndicator, tabs]);

  useEffect(() => {
    const onResize = () => positionIndicator();
    window.addEventListener('resize', onResize);
    positionIndicator();
    return () => window.removeEventListener('resize', onResize);
  }, [positionIndicator]);

  return (
    <div className={`${styles.container} ${className}`}>
      <div ref={headerRef} className={styles.tabHeader}>
        <span
          ref={indicatorRef}
          className={styles.indicator}
          aria-hidden='true'
        />
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            ref={(el) => (btnRefs.current[index] = el)}
            className={`${styles.tabButton} ${
              index === activeTab ? styles.active : ''
            }`}
            onClick={() => setActive(index)}
            type='button'
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className={`${styles.tabContent} ${tabContentClass}`}>
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

export default Tab;
